import type { AppProps } from 'next/app';
import React, { ReactElement, ReactNode } from 'react';
import { appWithTranslation } from 'next-i18next';
import AppLayout from '@components/app-layout/AppLayout';
import { NextPage } from 'next';
import '@styles/antd.less';
import '../../styles/globals.scss';
import nextI18NextConfig from 'next-i18next.config.js';
import ErrorBoundary from '@components/ErrorBoundary';

export type NextPageWithLayout = NextPage & {
    getLayout?: (page: ReactElement) => ReactNode;
};

type AppPropsWithLayout = AppProps & {
    Component: NextPageWithLayout;
};

function MyApp({ Component, pageProps }: AppPropsWithLayout) {
    const getLayout =
        Component.getLayout ?? ((page) => <AppLayout {...pageProps}>{page}</AppLayout>);
    return (
        <ErrorBoundary>
            {getLayout(<Component suppressHydrationWarning={true} {...pageProps} />)}
        </ErrorBoundary>
    );
}

export default appWithTranslation(MyApp, nextI18NextConfig);
